import { render, staticRenderFns } from "./sku_work.vue?vue&type=template&id=0880c4d2&scoped=true&"
import script from "./sku_work.vue?vue&type=script&lang=js&"
export * from "./sku_work.vue?vue&type=script&lang=js&"
import style0 from "./sku_work.vue?vue&type=style&index=0&id=0880c4d2&scoped=true&lang=css&"
import style1 from "./sku_work.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0880c4d2",
  null
  
)

export default component.exports